var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCareerImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 115,
    viewBox: "0 0 110 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1583_44133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3749 102.219C45.638 96.1942 46.3997 85.1238 40.0763 77.4926C33.7529 69.8614 22.7389 68.5591 15.4758 74.5839C8.2128 80.6087 7.45109 91.679 13.7745 99.3102C20.0979 106.941 31.1119 108.244 38.3749 102.219Z",
    fill: "#C9E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9257 58.1299L58.6374 57.7565C59.5049 57.3377 60.3497 56.8733 61.1682 56.3652C61.4017 56.9554 61.6537 57.5478 61.9257 58.1299Z",
    fill: "#94D9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4158 61.2934L90.5466 60.854C91.5703 60.3678 92.5646 59.8219 93.5244 59.2191C93.8034 59.9231 94.1006 60.6145 94.4158 61.2934Z",
    fill: "#C7E1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.801 24.6699L82.4259 15.6546L68.8688 56.0642L96.2436 65.0794",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.801 24.6699L82.4259 15.6546L68.8688 56.0642L96.2436 65.0794",
    stroke: "#00479B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1583_44133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3673 50.3384L5.99417 49.1828C7.37654 48.0445 8.51959 46.6414 9.35677 45.0553C10.1939 43.4692 10.7085 41.7317 10.8705 39.9441C11.3526 33.5089 6.84125 29.4253 6.34052 28.9902L73.7136 30.1458C75.1062 31.7296 76.1582 33.5851 76.8037 35.596C77.4492 37.607 77.6743 39.7302 77.465 41.8327C77.0566 45.0398 75.618 48.026 73.3673 50.3384Z",
    fill: "#2E83EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8979 48.8891L7.58065 47.7859C9.68819 45.6222 10.9627 42.7777 11.1771 39.759C11.2595 38.0229 10.9942 36.2879 10.3968 34.6568C9.79936 33.0256 8.88206 31.5314 7.69917 30.2627L72.2363 31.3696C72.8403 31.9741 76.6637 35.924 75.9229 41.5245C75.4719 44.3735 74.0491 46.9768 71.8979 48.8891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4789 34.9182L62.7774 35.8152",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9417 38.4448L69.2079 39.4442",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4717 42.8542L54.0045 43.6009",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.66 71.3769L86.9713 72.6514C87.0356 72.4873 87.0643 72.3113 87.0556 72.1352C87.0468 71.9591 87.0008 71.7869 86.9206 71.63C86.7666 71.3822 86.535 71.1928 86.2621 71.0917C85.9892 70.9905 85.6906 70.9832 85.4132 71.071C83.3056 68.6559 82.0725 65.5966 81.9137 62.3893C81.8597 60.4721 82.1827 58.563 82.8642 56.7712C83.5457 54.9793 84.5723 53.34 85.8853 51.9468C86.1608 51.9824 86.4405 51.9304 86.685 51.7979C86.9295 51.6655 87.1264 51.4593 87.2481 51.2086C87.3187 51.007 87.3224 50.788 87.2588 50.5842L12.9474 49.3096C12.2368 50.0591 7.74014 54.8488 8.35461 61.9197C8.71049 65.463 10.2243 68.7883 12.66 71.3769Z",
    fill: "#00479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.076 70.0189L85.4283 71.0713C83.4907 64.8158 83.6674 58.0923 85.9308 51.9476L24.404 50.8923C23.0528 52.3576 22.0131 54.084 21.3483 55.9661C20.6835 57.8483 20.4077 59.8466 20.5375 61.8392C20.8058 64.8782 22.0473 67.748 24.076 70.0189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4761 57.1628L27.3701 56.1833",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1297 60.9955L45.374 60.3308",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2593 65.819L36.7228 65.0037",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9272 93.3148L86.2386 94.5894C86.3671 94.4261 86.4477 94.23 86.4713 94.0232C86.4949 93.8164 86.4607 93.6071 86.3724 93.4188C86.1903 93.1545 85.9153 92.9692 85.6027 92.9003C85.2901 92.8313 84.963 92.8838 84.6873 93.0472C82.606 90.6873 81.3822 87.6891 81.2152 84.5411C81.1643 82.6578 81.4892 80.7833 82.1706 79.0279C82.8521 77.2724 83.8763 75.6716 85.183 74.3195C86.02 74.608 86.7461 74.2853 86.8749 73.8534C87.0037 73.4215 86.6301 73.0876 86.5785 73.0029L12.2671 71.7283C11.5564 72.4778 7.06177 77.1533 7.67872 84.0795C8.03208 87.547 9.52713 90.7969 11.9272 93.3148Z",
    fill: "#006AEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4549 89.2225L84.7247 90.4277C84.2686 88.1044 84.0549 85.7396 84.0872 83.3717C84.1178 80.632 84.483 77.9065 85.1745 75.2561L14.7152 74.0475C14.0315 74.5537 9.72752 77.8387 10.3493 82.7162C10.7831 86.1662 13.4889 88.4976 14.4549 89.2225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8531 79.1899L24.7471 78.2104",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3763 82.2208L17.7567 81.1296",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3106 86.0506L33.7817 85.2354",
    stroke: "#195FCE",
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_44133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.0557,
    height: 103.659,
    fill: "white",
    transform: "translate(12) rotate(6.47899)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1583_44133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.4208,
    height: 64.2192,
    fill: "white",
    transform: "translate(6.34052 28.9902) rotate(0.982644)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerImg);
export default __webpack_public_path__ + "static/media/CareerImg.1aefc36d53f77a3a8315ff75e327da9b.svg";
export { ForwardRef as ReactComponent };